function descWithCodigoInterno(object) {
  return object.codigoInterno ? `${object.codigoInterno} - ${object.descricao}` : object.descricao;
}

export default {
  descWithCodigoInterno,
};
